module.exports = __webpack_public_path__ + "img/blue-lock.c79461cb.svg";